export default {
  namespaced: true,
  state: {
    'showGallery': false,
    'imagesGallery': [],
    'galleryIndex': 0
  },
  mutations: {
    SET_SHOW_GALLERY: (state, show) => {
      state.showGallery = show
    },
    SET_IMAGES_GALLERY: (state, images) => {
      state.imagesGallery = images
    },
    SET_GALLERY_INDEX: (state, indx) => {
      state.galleryIndex = indx
    }
  },
  actions: {
    defineGallery (context, {show, images, index}) {
      context.commit('SET_SHOW_GALLERY', show)
      context.commit('SET_IMAGES_GALLERY', images)
      context.commit('SET_GALLERY_INDEX', index)
    }
  },
  getters: {
    'showGallery': state => state.showGallery,
    'imagesGallery': state => state.imagesGallery,
    'galleryIndex': state => state.galleryIndex
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/gallery.js